export default "__VITE_ASSET__C8GD3Unb__"